module.exports = __webpack_public_path__ + "static/img/course_default.6a376d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course_default.png
// module id = 6DTk
// module chunks = 1